<template>
    <div>
        <ul v-if="!$route.params.pathMatch">
            <li v-for="(page, key) in pages" :key="key">
                <a :href="key">
                    {{ key }}
                </a>
            </li>
        </ul>
        <component :is="pageComponent" v-else></component>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pages: {
                'dnd5e/character': () => import('@/core/ruleset/dnd5e/CharacterDebug'),
            },
        };
    },
    computed: {
        pageComponent() {
            let page = this.$route.params.pathMatch;
            if (!page) {
                return null;
            }

            return this.pages[page];
        },
    },
};
</script>
